import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const listTurnOrder = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.getlist'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder');
        Store.dispatch(loadingActions.loadingEnd('turnorder.getlist'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.getlist'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.getlist'));
        return e.response.data;
    }
};

export const addTurnOrder = async (tableId, name, value, token) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.addTurnOrder'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder', {
            name, 
            value, 
            token
        });
        Store.dispatch(loadingActions.loadingEnd('turnorder.addTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.addTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.addTurnOrder'));
        return e.response.data;
    }
};

export const editTurnOrder = async (tableId, id, name, value, token) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.editTurnOrder'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/'+id, {
            name,
            value,
            token
        });
        Store.dispatch(loadingActions.loadingEnd('turnorder.editTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.editTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.editTurnOrder'));
        return e.response.data;
    }
};

export const removeTurnOrder = async (tableId, id) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.deleteTurnOrder'));
    try {
        let resp = await axios.delete(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/'+id);
        Store.dispatch(loadingActions.loadingEnd('turnorder.deleteTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.deleteTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.deleteTurnOrder'));
        return e.response.data;
    }
};

export const moveTurnOrder = async (tableId, id, direction) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.moveTurnOrder'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/'+id+'/move/'+direction);
        Store.dispatch(loadingActions.loadingEnd('turnorder.moveTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.moveTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.deleteTurnOrder'));
        return e.response.data;
    }
};

export const nextTurnOrder = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.nextTurnOrder'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/next');
        Store.dispatch(loadingActions.loadingEnd('turnorder.nextTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.nextTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.nextTurnOrder'));
        return e.response.data;
    }
};

export const prevTurnOrder = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.prevTurnOrder'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/prev');
        Store.dispatch(loadingActions.loadingEnd('turnorder.prevTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.prevTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.prevTurnOrder'));
        return e.response.data;
    }
};

export const orderAscTurnOrder = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.orderAscTurnOrder'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/order/asc');
        Store.dispatch(loadingActions.loadingEnd('turnorder.orderAscTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.orderAscTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.orderAscTurnOrder'));
        return e.response.data;
    }
};

export const orderDescTurnOrder = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.orderDescTurnOrder'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/order/desc');
        Store.dispatch(loadingActions.loadingEnd('turnorder.orderDescTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.orderDescTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.orderDescTurnOrder'));
        return e.response.data;
    }
};

export const clearTurnOrder = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('turnorder.clearTurnOrder'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/turnorder/reset');
        Store.dispatch(loadingActions.loadingEnd('turnorder.clearTurnOrder'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            Store.dispatch(loadingActions.loadingEnd('turnorder.clearTurnOrder'));
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('turnorder.clearTurnOrder'));
        return e.response.data;
    }
};